import parseConsentCodes from 'app/components/analytics-builder/parseConsentCodes';

/**
 * Require at least one consent code in a multi-select.
 *
 * validateRequired cannot do this job: the multi-select serializes its
 * selection to a hidden input as JSON, so an empty selection arrives as the
 * two-character string '[]' and passes a trim-length check. This parses the
 * value the same way the build does and rejects an empty result.
 *
 * @param {string} msg - Error message shown when nothing is selected
 * @returns {Function} Validator for the form's validators array
 */
export default function validateConsentCodesSelected(msg = 'Select at least one consent code') {
  return function _validateConsentCodesSelected(value) {
    return parseConsentCodes(value).length > 0 ? null : msg;
  };
}
